import styles from "./ModalOverlay.module.scss";

const ModalOverlay = () => {
  return <div className={styles["modal-overlay"]}></div>;
};

export default ModalOverlay;
